import React from 'react'
import {Tabs} from '@therms/atalaya'
import {Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {NotificationSettings} from './screens/NotificationSettings'
import {NOTIFICATIONS_ROUTES} from '@src/modules/Notifications/constants'
import {Notifications} from '@src/modules/Notifications/router/screens/Notifications'

function NotificationsRoutes() {
  const history = useHistory()
  const location = useLocation()

  // Tab keys are route paths. Anything that isn't the settings screen
  // (root, /:notificationId deep links) belongs to the Notifications tab.
  const currentKey =
    location.pathname === NOTIFICATIONS_ROUTES.SETTINGS
      ? NOTIFICATIONS_ROUTES.SETTINGS
      : NOTIFICATIONS_ROUTES.__ROOT__

  return (
    <div className="mx-auto flex w-full max-w-(--breakpoint-lg) flex-col px-sm">
      <div className="sticky top-0 z-sticky bg-background py-sm">
        <Tabs
          currentKey={currentKey}
          onTabClick={(key) => history.push(key)}
          pills
        >
          <Tabs.Tab
            tabKey={NOTIFICATIONS_ROUTES.__ROOT__}
            title="Notifications"
          />
          <Tabs.Tab
            tabKey={NOTIFICATIONS_ROUTES.SETTINGS}
            title="Preferences"
          />
        </Tabs>
      </div>

      <div className="mt-base w-full">
        <Switch>
          <Route
            component={NotificationSettings}
            path={NOTIFICATIONS_ROUTES.SETTINGS}
          />

          <Route
            component={Notifications}
            path={NOTIFICATIONS_ROUTES.VIEW_NOTIFICATION}
          />

          <Route component={Notifications} />
        </Switch>
      </div>
    </div>
  )
}

export {NotificationsRoutes}
